import React from "react"
import { useSelector } from "react-redux"

import Tags from "@root/components/Tags"
import { useAppDispatch } from "@root/store"
import { selectContactTags } from "@root/store/selectors"
import { addContactTag, removeContactTag } from "@root/store/thunks"
import { Tag } from "@root/store/types"

export interface Props {}

const ContactTags: React.FC<Props> = () => {
  const tags = useSelector(selectContactTags)
  const dispatch = useAppDispatch()

  const addTag = React.useCallback(
    (tag: Tag) => {
      dispatch(addContactTag(tag))
    },
    [dispatch]
  )

  const removeTag = React.useCallback(
    (tag: Tag) => {
      dispatch(removeContactTag(tag))
    },
    [dispatch]
  )

  return <Tags tags={tags} onAddTag={addTag} onRemoveTag={removeTag} />
}

export default ContactTags
